var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bubble-icon',{staticClass:"category",attrs:{"shape":_vm.slug,"name":_vm.name,"size":_vm.size,"background":_vm.background}})}
var staticRenderFns = []

export { render, staticRenderFns }